import { MicroFrontend } from '@praxis/component-microfrontend'
import { MFEProps } from './MFEProps'
import { envConfigs } from '../apiConfig'
import WorkspaceViewTabs from 'workspaces/components/WorkspaceViewTabs'
import useWorkspaceInfo from 'workspaces/hooks/useWorkspaceInfo'
import BreadcrumbWorkspace from 'workspaces/components/WorkspaceBreadcrumb'
import LoadingPage from 'layout/LoadingPage'
import { useContext } from 'react'
import { UserContext } from '../App/UserContext'

export type TileBoardsMFEProps = MFEProps

const getBreadcrumbs = (workspace: any) => {
  if (!workspace) {
    return []
  }

  return [
    { content: 'Workspaces', to: '/workspaces' },
    {
      content: (
        <BreadcrumbWorkspace
          workspaceId={workspace?.id}
          workspaceDescription={workspace?.description}
        />
      ),
      to: `/workspaces/${workspace?.id}`,
    },
    {
      content: 'Collab Canvas',
      to: `/workspaces/${workspace?.id}/boards`,
    },
  ]
}

export const TileBoardsMFE = ({ environment }: TileBoardsMFEProps) => {
  const { workspace } = useWorkspaceInfo()
  const { isDark, sparkUser } = useContext(UserContext)

  return (
    <>
      <WorkspaceViewTabs
        workspaceId={workspace?.id || ''}
        workspaceType={workspace?.workspaceType?.code || 0}
        workspaceDescription={workspace?.description || ''}
        breadcrumbs={getBreadcrumbs(workspace)}
        includeSparkPadding
      />
      <MicroFrontend
        environment={environment}
        src={envConfigs[environment].tile.boardsInWorkspaceMfeSrc}
        isPLMView
        workspaceId={workspace?.id || ''}
        Loading={LoadingPage}
        isDarkPLM={isDark}
        plmUser={sparkUser}
      />
    </>
  )
}
